import 'components/resources/show/resource-show-sidebar-pricing/resource-show-sidebar-pricing.css';
import 'components/resources/show/resource-show-sidebar-pricing/download-btn-options/img/sale.svg';
